import apiRequest from '@app/utils/apiRequest';

export const requestGetCddNeedFuList = (params) => apiRequest.get(`/candidate/cdd-need-fu-list/`, {params: params});
export const requestSaveCddNeedFuNote = (data) => apiRequest.post(`/candidate/cdd-need-fu-list/`, data);
